import { ProposalVehicleData } from '@/types/management.types'
import React from 'react'

interface GeneralDataProps {
  generalInfo: ProposalVehicleData | undefined
  // Label de la última fila (por defecto "Período cotización"). Se usa,
  // por ejemplo, para mostrar "Plazo" en la pantalla de revisión previa a
  // solicitar un nuevo arrendamiento.
  periodoLabel?: string
}

const VehicleData: React.FC<GeneralDataProps> = ({
  generalInfo = {
    marca: 'Toyota',
    modelo: 'Corolla',
    submarcaVersion: '2020',
    tipo: 'Sedán',
    valorFactura: '30000',
    costoAccesorios: '5000',
    descripcionAccesorios: 'Sistema de navegación, cámara de reversa',
    periodoCotizacion: '12 meses',
  },
  periodoLabel = 'Período cotización',
}) => {
  const {
    marca,
    modelo,
    submarcaVersion,
    tipo,
    valorFactura,
    costoAccesorios,
    descripcionAccesorios,
    periodoCotizacion,
  } = generalInfo || {}

  const formatToPesos = (value: string): string => {
    const numericValue = parseFloat(value)
    if (isNaN(numericValue)) return value

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue)
  }

  return (
    <div className="w-full">
      {/* Header */}
      <div className="bg-[#E4EFFF] px-6 py-3 ">
        <h2 className="text-sm font-semibold text-[#000000] uppercase tracking-wide text-center">
          DATOS DEL VEHÍCULO
        </h2>
      </div>

      {/* Content Table */}
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left Column */}
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0 w-1/2">
                Marca
              </span>
              <span className="text-sm  text-gray-600 font-medium">
                {marca}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0 ">
                Modelo
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {modelo}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                Submarca y versión
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {submarcaVersion}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                Tipo
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {tipo}
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0 w-1/2">
                Valor factura
              </span>
              <span className="text-sm  text-gray-600 font-medium">
                {formatToPesos(valorFactura || '0')}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0 ">
                Costo accesorios
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {formatToPesos(costoAccesorios || '0')}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                Descripción accesorios
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {descripcionAccesorios}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                {periodoLabel}
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {periodoCotizacion}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VehicleData
